import React, { createContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { decryptData, encryptData } from '../services/dashboard-service/encryptionService';

export const userContext = createContext()


export const UserProvider = ({ children }) => {
    const navigate = useNavigate()
    const [user, setUser] = useState({})
    const [loading, setLoading] = useState(true)

    const updateUser = (newUserData) => {
        localStorage.setItem("userData",JSON.stringify(encryptData(newUserData)))
        setUser(newUserData)
    }

    useEffect(() => {
        const loadUserData = () => {
            const userData = localStorage.getItem("userData") ? JSON.parse(decryptData(localStorage.getItem("userData"))) : null;
            if (!userData) {
                setTimeout(() => navigate("/login"), 0)
                setLoading(false)
                return;
            }
            setUser(userData)
            setLoading(false)
        }
        loadUserData()
        const handleStorageChange = (event) => {
            if(event.key === "userData"){
                loadUserData()
            }
        }
        window.addEventListener("storage",handleStorageChange)
        return () => {
            window.removeEventListener("storage",handleStorageChange)
        }
    }, [navigate])

    return (
        <userContext.Provider value={{ user, loading, setUser,updateUser }} >
            {children}
        </userContext.Provider>
    )
}


export const useUserContext = () => {
    return React.useContext(userContext);
};